import * as yup from 'yup';

import { FormErrors, phoneField } from '@blockpulse3/data/shared';

export const phoneSchema = yup.object({
  phone: phoneField.required(FormErrors.RequiredField),
});
